import React, {useContext} from "react";
import {Oval} from "react-loader-spinner";
import {DataContext} from "../Context/DataContext";

export default function Loader() {
	const {pageHeight} = useContext(DataContext);

	return (
		<div className="page-content loader" style={{minHeight: pageHeight}}>
			<Oval color="var(--blue)" secondaryColor="var(--blue-50)" height={80} width={80} />
			<p>Calculando los mercados de destino</p>
		</div>
	);
}
